/** @module csi/action/RemoveSort */
define([
	"csi/def",
	"csi/def/Action",
	"csi/def/ActionFactory",
	"csi/reflectionHints"
], function(def,Action,ActionFactory,reflectionHints) {

	return ActionFactory.declare("tableRemoveSort", Action, {
		constructor: function() {
			this.m_id = "TableRemoveSort";
			this.m_typeControl = def.ACTION_ICON;
			this.m_class = "iconRemoveSort";
		},

		/**
		 * Disable if first level of view is filtered or if custom view sort attribute is set don't enable the widget
		 */
		hasAccess: function(ctx) {
			var view = ctx.view;
			var sortSettings = view.get("sortSettings");
			return sortSettings && sortSettings.length && !view.get("customViewSortExists") && this.inherited(arguments);
		},

		/**
		 * Validate that action is available based on view configuration
		 */
		validate: function(ctx) {
			var view = ctx.view;
			var	r = view.relRoot;

			if (!r || ctx.bPrint || (ctx.fd && !ctx.fd.m_bEditable) || !view.canSort()) {
				return false;
			}
			
			// allow if the view is ordered by default, either being stored in a vector or in each result in a numeric attribute 
			return r.bOrdered || r.typeSortAttribute;
		}
	});
});